import { call, put, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACT from "./actions";
import {  getCryptoApi } from "helpers/backend_helper";

import {errorMsg, successMsg} from "helpers/toastr";
 /**
      * Used for calling crypto listing api
      */

function* getCryptoSaga({ payload }) {
  try {
    const response = yield call(getCryptoApi, payload);
    if (response.status == "failure") {
      return yield put(ACT.getCryptoFail(response.message));
    }
    yield put(ACT.getCryptoSuccess(response));
  } catch (error) {
    yield put(ACT.getCryptoFail(error));
  }
}



function* cryptoSaga() {
  yield takeEvery(CONST.GET_CRYPTO, getCryptoSaga);
}

export default cryptoSaga;
